import React from 'react'
import { Volunteer, TableDataItem } from "../types/volunteers.type"
import { flexRender, Table } from '@tanstack/react-table'
import { TableBody, TableCell } from '../../../shared/components/ui/table'
import { Skeleton } from '@/shared/components/ui/skeleton'
import TableRow from '@/features/homeowners/components/table-row'

type VolunteerTableBodyProps = {
    table: Table<TableDataItem>,
    isLoading: boolean,
}

function VolunteerTableBody({ table, isLoading }: VolunteerTableBodyProps) {
    if (isLoading) {
        return (
            <TableBody>
                {[...Array(10).keys()].map(row => (
                    <TableRow key={`${row}-home-owner-table-loading-key`}>
                        <TableCell
                            colSpan={table.getAllColumns().length} className="text-center"
                        >
                            <Skeleton className="w-full h-10" />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    if (!isLoading && !table.getRowModel().rows.length) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell
                        colSpan={table.getAllColumns().length} className="text-center"
                    >
                        <span className='text-muted-foreground mt-5 h-10'>
                            No data found
                        </span>
                    </TableCell>
                </TableRow>
            </TableBody>
        )
    }

    return (
        <TableBody>
            {table.getRowModel().rows.map((row) => (
                <TableRow
                    key={row.id}
                    data-state={row.getIsSelected() && "selected"}
                >
                    {row.getVisibleCells().map((cell) => (
                        <TableCell key={cell.id} className="py-4">
                            {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                            )}
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    )
}

export default VolunteerTableBody